export default function Whitespace() {
  return ' ';
}
